import axios from "axios";
import React, { useState, useEffect } from "react";

function SalaryPage({ userDetails }) {
  const [responseMessage, setResponseMessage] = useState("");
  const [clients, setClients] = useState([]);
  const [claimed, setClaimed] = useState(null);
  const [sales, setSales] = useState([]);
  const [selfSale, setSelfSale] = useState(0);
  var [totalSales, setTotalSales] = useState({ leftSales: [], rightSales: [] });

  const sumValues = (arr) => {
    return arr.reduce((total, obj) => {
      return total + parseFloat(obj.received);
    }, 0);
  };

  window.addEventListener("beforeunload", () => {
    localStorage.removeItem("sale_history");
    localStorage.removeItem("all_clients");
  });

  function getNodes(parent) {
    totalSales = { leftSales: [], rightSales: [] };
    setTotalSales(totalSales);
    const parentRoot = clients.find(
      (element) => element["client_id"] === parent
    );
    const rootSalesData = sales.filter((s) => s["agent_name"] === parent);
    var rootSales = 0;

    if (rootSalesData) {
      rootSales = sumValues(rootSalesData);
    }
    setSelfSale(rootSales);
    const leftChild = clients.find(
      (element) => element["client_id"] === parentRoot["left_child"]
    );
    const rightChild = clients.find(
      (element) => element["client_id"] === parentRoot["right_child"]
    );

    if (leftChild) {
      const leftSalesData = sales.filter(
        (s) => s["agent_name"] === leftChild["client_id"]
      );
      var leftSales = 0;

      if (leftSalesData) {
        leftSales = sumValues(leftSalesData);
        totalSales = {
          ...totalSales,
          leftSales: [...totalSales.leftSales, leftSales],
        };
        setTotalSales(totalSales);
      }
      getChildsLeft(leftChild["left_child"]);
      getChildsLeft(leftChild["right_child"]);
    }

    if (rightChild) {
      const rightSalesData = sales.filter(
        (s) => s["agent_name"] === rightChild["client_id"]
      );
      var rightSales = 0;

      if (rightSalesData) {
        rightSales = sumValues(rightSalesData);
        totalSales = {
          ...totalSales,
          rightSales: [...totalSales.rightSales, rightSales],
        };
        setTotalSales(totalSales);
      }
      getChildsRight(rightChild["left_child"]);
      getChildsRight(rightChild["right_child"]);
    }
  }

  // Fetch Sales
  const fetchSales = async () => {
    try {
      const response = await axios.get(
        "https://api.swalokgroup.com/api/get-sale-invoice"
      );
      setSales(response.data);
      localStorage.setItem("sale_history", JSON.stringify(response.data));
    } catch (error) {
      console.log(error);
    }
  };

  // Fetch clients
  const fetchClients = async () => {
    try {
      const response = await axios.get(
        "https://api.swalokgroup.com/api/get-all-clients"
      );
      setClients(response.data);
      localStorage.setItem("all_clients", JSON.stringify(response.data));
    } catch (error) {
      console.log(error);
    }
  };

  function getChildsLeft(parent) {
    if (!parent) {
      return;
    }

    const rootChildrens = clients.find(
      (element) => element["client_id"] === parent
    );
    const salesData = sales.filter(
      (s) => s["agent_name"] === rootChildrens["client_id"]
    );
    var salesTotal = 0;

    if (salesData) {
      salesTotal = sumValues(salesData);
      totalSales = {
        ...totalSales,
        leftSales: [...totalSales.leftSales, salesTotal],
      };
      setTotalSales(totalSales);
    }
    if (rootChildrens["left_child"]) {
      getChildsLeft(rootChildrens["left_child"]);
    }
    if (rootChildrens["right_child"]) {
      getChildsLeft(rootChildrens["right_child"]);
    }
  }

  function getChildsRight(parent) {
    if (!parent) {
      return;
    }

    const rootChildrens = clients.find(
      (element) => element["client_id"] === parent
    );
    const salesData = sales.filter(
      (s) => s["agent_name"] === rootChildrens["client_id"]
    );
    var salesTotal = 0;

    if (salesData) {
      salesTotal = sumValues(salesData);
      totalSales = {
        ...totalSales,
        rightSales: [...totalSales.rightSales, salesTotal],
      };
      setTotalSales(totalSales);
    }
    if (rootChildrens["left_child"]) {
      getChildsRight(rootChildrens["left_child"]);
    }
    if (rootChildrens["right_child"]) {
      getChildsRight(rootChildrens["right_child"]);
    }
  }

  useEffect(() => {
    const loadData = async () => {
      try {
        // Fetch all data in parallel
        await Promise.all([fetchClients(), fetchSales()]);
      } catch (error) {
        console.log(error);
      }
    };

    // Check if data exists in localStorage to prevent re-fetching
    const storedClients = localStorage.getItem("all_clients");
    const storedSales = localStorage.getItem("sale_history");
    if (!storedSales || !storedClients) {
      loadData();
    } else {
      setClients(JSON.parse(storedClients));
      setSales(JSON.parse(storedSales));
    }
  }, [setClients, setSales]);

  useState(() => {
    const fetchMileStones = async () => {
      try {
        const response = await axios.get(
          `https://api.swalokgroup.com/api/get-milestone/${userDetails.client_id}`
        );
        setClaimed(response.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchMileStones();
  });

  const salary = [
    { salaryBonus: "500000", reward: "5000" },
    { salaryBonus: "1000000", reward: "10000" },
    { salaryBonus: "2500000", reward: "25000" },
    { salaryBonus: "5000000", reward: "50000" },
    { salaryBonus: "10000000", reward: "250000" },
    { salaryBonus: "25000000", reward: "350000" },
    { salaryBonus: "50000000", reward: "500000" },
    { salaryBonus: "100000000", reward: "1000000" },
    { salaryBonus: "250000000", reward: "2500000" },
    { salaryBonus: "500000000", reward: "5000000" },
    { salaryBonus: "1000000000", reward: "10000000" },
  ];

  const claimReward = async (rewardAmt) => {
    setResponseMessage("");

    if (selfSale < 1) {
      return;
    }

    try {
      await axios.post("https://api.swalokgroup.com/api/claim-mile-direct", {
        client_id: userDetails.client_id,
        amount: rewardAmt,
        category: "Reward",
      });

      setResponseMessage(
        "Milestone Reward claimed successfully! Check status for approval."
      );
      setTimeout(() => {
        setResponseMessage("");
        window.location.reload();
      }, 1000);
    } catch (error) {
      setResponseMessage("Reward has already been claimed.");
      setTimeout(() => {
        setResponseMessage("");
      }, 1000);
    }
  };

  function getMinValue(val1, val2) {
    return val1 < val2 ? val1 : val2;
  }

  function isMileStoned(miles) {
    const amt = getMinValue(
      totalSales.leftSales.reduce((acc, value) => acc + value, 0),
      totalSales.rightSales.reduce((acc, value) => acc + value, 0)
    );
    const claimedAmt = claimed
      ? claimed.reduce((acc, value) => acc + parseFloat(value.amount), 0) * 100
      : 0;

    return amt - claimedAmt >= miles;
  }
  return (
    <section className="py-5">
      <div className="container text-center">
        <div className="sec-subheading">
          <hr />
          <span>
            Matching Reached ₹ &nbsp;
            {getMinValue(
              totalSales.leftSales.reduce((acc, value) => acc + value, 0),
              totalSales.rightSales.reduce((acc, value) => acc + value, 0)
            ) -
              (claimed
                ? claimed.reduce(
                    (acc, value) => acc + parseFloat(value.amount),
                    0
                  ) * 100
                : 0)}
          </span>
          <hr />
        </div>
        <div className="d-flex justify-content-between">
          <p className="sec-heading fs-4">Swalok Associate Salary Plan</p>
          {claimed && clients.length > 0 && (
            <button
              className="admin-btn px-3"
              onClick={() => {
                getNodes(userDetails.client_id);
              }}
            >
              Fetch Matching
            </button>
          )}
        </div>

        <div className="rounded table-responsive text-center my-4">
          <table className="w-100">
            <thead>
              <tr className="bg-light para-text">
                <th className="py-3 px-2">S No</th>
                <th className="py-3 px-2">Matching Business</th>
                <th className="py-3 px-2">Reward</th>
                <th className="py-3 px-2">Claim</th>
              </tr>
            </thead>

            <tbody>
              {salary.map((milestones, index) => (
                <tr key={index} className="text-muted">
                  <td className="py-3 px-3">{index + 1}</td>
                  <td className="py-3 px-3">{milestones.salaryBonus}</td>
                  <td className="py-3 px-3">{milestones.reward}/Month</td>
                  <td className="text-success cursor-pointer">
                    {isMileStoned(parseFloat(milestones.salaryBonus)) ? (
                      <button
                        className="admin-btn px-3 py-1"
                        onClick={() => {
                          claimReward(milestones.reward);
                        }}
                      >
                        Claim
                      </button>
                    ) : (
                      <p style={{ color: "red" }}>Not Eligible</p>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* table ends */}
      </div>
      {responseMessage && (
        <div className="response-message d-flex justify-content-between">
          <p className="my-0 mx-auto">{responseMessage}</p>
          <p
            className="my-0 cursor-pointer"
            onClick={() => setResponseMessage("")}
          >
            <i className="fa-solid fa-xmark"></i>
          </p>
        </div>
      )}
    </section>
  );
}

export default SalaryPage;
